import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";




function ContactUs() {
  return (
    <>
      <Helmet>
        <title>WebsiteSEO</title>
        <meta name="description" content={"Website SEO"} />
        <meta name="keywords" content={"Website SEO  "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/contact-us"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Contact Us</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Contact Us</li>
      </ul>
    </div>
  </div>
  {/* CONTACTS
   ============================================= */}
  <section className="bg--scroll contacts-1 inner-page-hero pb-60 contacts-section division">
    <div className="container">
      <div className="row">
        {/* CONTACTS INFO */}
        <div className="col-lg-6">
          <div className="contacts-info">
            {/* Module Subtitle */}
            <span className="module-subtitle">Contact Us</span>
            {/* Title */}
            <h2 className="fs-20">Need Help? Get in Touch</h2>
            {/* Text */}
            <p>
              Feel free to talk to our online representative at any time you please using our Live Chat system on our website or one of the below instant messaging programs.<br />
              Please be patient while waiting for response. (24/7 Support!)
              <br />
              Phone General Inquiries:<a href="tel:+971 55 570 9788">+971 55 570 9788</a>
            </p>
            <h6 className="fs-20">Contact us:</h6>
            <p>
              Address : Office# 114 Al Ahbabi Building Damascus Street, Al Qusais<br />
              Dubai, United Arab Emirates<br />
              Mobile:<a href="tel:+971 55 570 9788">+971 55 570 9788</a><br />
              E-mail:<a href="mailto:sales@websiteseo.ae">sales@websiteseo.ae </a>
            </p>
            {/* Title */}
            <h6 className="fs-20">Connect with us:</h6>
            {/* Socials Links */}
            <ul className="contacts-info-socials ico-25">
              <li><a href="https://www.facebook.com/websiteseodotae" target="blank"><span className="flaticon-facebook" /></a></li>
              <li><a href="https://x.com/websiteseodotae" target="blank"><span className="flaticon-twitter" /></a></li>
              <li><a href="https://www.linkedin.com/company/websiteseo-ae/" target="blank"><span className="flaticon-linkedin-sign" /></a></li>
              <li><a href="https://www.instagram.com/websiteseo.ae" target="blank"><span className="flaticon-instagram" /></a></li>
            </ul>
          </div>
        </div>	{/* END CONTACTS INFO */}
        {/* CONTACT FORM */}
        <div className="col-lg-6">
          <div className="form-wrapper">
            <form id="contactform1" className="row contact-form">
              <div id="response1" />
              {/* Contact Form Input */}
              <div className="col-md-12">
                <input type="text" name="cf_fname" id="cf_fname" className="form-control name" placeholder="Name *" required />
              </div>
              <div className="col-md-12">
                <input type="text" name="cf_phone" id="cf_phone" className="form-control name" placeholder="Contact Number *" required />
              </div>
              <div className="col-md-12">
                <input type="email" name="cf_email" id="cf_email" className="form-control email" placeholder="Email Address *" required />
              </div>
              <div className="col-md-12">
                <textarea className="form-control message" name="cf_msg" id="cf_msg" rows={6} placeholder="Message" defaultValue={""} />
              </div>
              {/* Contact Form Button */}
              <div className="col-md-12 form-btn">
                <button type="submit" className="btn btn--blue hover--tra-black submit">Submit Request</button>
              </div>
              {/* Contact Form Message */}
              {/*<div class="col-lg-12 contact-form-msg">
                              <span class="loading"></span>
                          </div>*/}
            </form>  {/* End contact-form */}
          </div>  {/* End form-wrapper */}
        </div>	{/* END CONTACT FORM */}
      </div>    {/* End row */}
    </div>	   {/* End container */}
    {/* WAVE SHAPE BOTTOM */}
    <div className="wave-shape-bottom fill--white">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 135">
        <path fillOpacity={1} d="M0,96L1440,128L1440,320L0,320Z" />
      </svg>
    </div>
  </section>	{/* END CONTACTS */}
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default ContactUs;
